import { Breakpoints } from '@zocdoc-frontend-common/styles-grid';

export const ARROW_WIDTH = 36;
export const SLOT_HEIGHT = 32;
export const ROW_GUTTER_WIDTH = 8;
export const COLUMN_GUTTER_WIDTH = 8;
export const MOBILE_SLOT_WIDTH_XXSMALL = 88;

// This constant determines how many days of availability will be loaded on the server-side
export const MAX_NUM_DAYS = 7;

export const DEFAULT_COLUMN_BREAKPOINTS = {
    3: Breakpoints.small,
    4: Breakpoints.medium,
    5: Breakpoints.large,
};

export const DEFAULT_INITIAL_ROW_COUNT = 4;
